import {createContext, FC, Suspense, useContext} from 'react';
import {Outlet, RouteObject, generatePath} from 'react-router-dom';
import Loader from 'components/Loader';
import {ResourceContext, ResourceProps} from '@refinedev/core';

export function Lazily(Component: FC, props?: any) {  
  return (
    <Suspense fallback={<Loader />}>
      <Component {...props} />
    </Suspense>
  );
}

export function generatePathWithDefaultValues(path: string, defaultValues?: any) {
  const url = generatePath(path);
  if (!defaultValues) return url;
  return url + '?default=' + encodeURI(JSON.stringify(defaultValues));
}

export function generateListPath(resource: string) {
  return generatePath('/' + resource);
}

export function generateCreatePath(resource: string, defaultValues?: any) {
  const url = generatePath('/' + resource + '/create');
  if (!defaultValues) return url;
  return url + '?default=' + encodeURI(JSON.stringify(defaultValues));
}

export function generateEditPath(resource: string, id: string) {
  return generatePath('/' + resource + '/:id', {id});
}

export function generateShowPath(resource: string, id: string) {
  return generatePath('/' + resource + '/:id/show', {id});
}
